'use client';
import { NotFoundOrError } from '@/components/NotFoundOrError';
import { Box, Stack } from '@mui/material';
import treydIcon from '@treyd-io/treyd-ui/assets/img/logo.svg';
import Image from 'next/image';
import { useEffect } from 'react';

export default function Error({
  error,
}: {
  error: Error & { digest?: string };
}) {
  useEffect(() => {
    console.log(error);
  }, [error]);

  return (
    <Stack direction="column" minHeight="100vh" padding="1.5rem">
      <Box width="1.75rem" height="1.75rem">
        <Image src={treydIcon} alt="Treyd" width={28} height={28} />
      </Box>
      <NotFoundOrError />
    </Stack>
  );
}
